import { useState } from 'react'
import { FaCommentDots } from 'react-icons/fa'

/**
 * 报名成功页的企业微信二维码。
 *
 * 图片不裁方形、可点击放大：企微导出的名片是竖版长图（实测 1220x2530），
 * 套进方框后二维码只剩 20 多像素，扫不出来。
 */
export default function WecomContactCard({ contact }) {
  const [zoomed, setZoomed] = useState(false)

  if (!contact || !contact.qrcodeImage) return null

  return (
    <div className="bg-blue-50 border border-blue-100 rounded-lg px-4 py-6 sm:p-6 mb-8 text-left">
      <div className="flex items-center gap-2 mb-4">
        <FaCommentDots className="shrink-0 text-primary-600" />
        <h4 className="font-bold text-gray-900">添加企业微信沟通报价</h4>
      </div>

      {/* 小屏竖排：横排时二维码 shrink-0 占 160px，右侧文字只剩约 50px，
          「微信或企业微信扫码添加」会被逐字折成一列。 */}
      <div className="flex flex-col items-center sm:flex-row sm:items-start gap-4">
        <button
          type="button"
          onClick={() => setZoomed(true)}
          className="bg-white rounded border border-gray-200 p-1 shrink-0 hover:border-primary-400 transition-colors"
        >
          <img
            src={contact.qrcodeImage}
            alt="企业微信二维码"
            className="max-h-40 max-w-[10rem] object-contain"
          />
        </button>
        <div className="text-sm text-gray-600 text-center sm:text-left sm:pt-1">
          <p className="mb-1">微信或企业微信扫码添加</p>
          <p className="text-xs text-gray-500">点击放大，手机上可长按保存或直接识别</p>
        </div>
      </div>

      {zoomed && (
        <div
          className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4"
          onClick={() => setZoomed(false)}
        >
          <img
            src={contact.qrcodeImage}
            alt="企业微信二维码"
            className="max-h-[85vh] max-w-full object-contain bg-white rounded p-2"
          />
        </div>
      )}
    </div>
  )
}
